module.exports = __webpack_public_path__ + "img/ba.ba705b134.svg";